import { useState } from "react"
import VideoForm from "../../admin/videos/VideoForm"
import VideosTable from "../../admin/videos/VideosTable"
import { Alert, Empty, Spin } from "antd"
import { useGetVideosQuery } from "../../../features/videos/videosApi"
import { useDispatch } from "react-redux"
import { editVideo, toggleModal } from "../../../features/videos/videosSlice"

export default function Videos() {
  const dispatch = useDispatch()

  const { data: videos, isLoading, isError, error } = useGetVideosQuery()

  // decide what to render 
  let render = null;
  if (isLoading) {
    render = <Spin />
  } else if (isError && error) {
    render = <Alert message="Error" description={typeof error?.data == 'string' ? error?.data : 'Something went wrong'}
      type="error"
      showIcon
    />
  } else if (!videos?.length) {
    render = <Empty description="No Videos Found" />
  } else {
    render = <VideosTable videos={videos} />
  }

  const openVideoModal = () => {
    dispatch(editVideo({}))
    dispatch(toggleModal(true))
  }
  return (
    <>
      <section className="py-6 bg-primary">
        <div className="mx-auto max-w-full px-5 lg:px-20">
          <div className="px-3 py-20 bg-opacity-10">
            <div className="w-full flex">
              <button className="btn ml-auto cursor-pointer" onClick={openVideoModal}>Add Video</button>
            </div>

            <div className="overflow-x-auto mt-4">
              {render}
            </div>
          </div>
        </div>

        <VideoForm />
      </section>

    </>
  )
}